import React, { useContext } from "react";
import styled from "styled-components";
import Location from "./Location";
import { LocationContext } from "../../locationData";

export default function SideBarDisplay() {
  const [loading, location] = useContext(LocationContext);

  return (
    <StyledDisplayWrapper>
      {loading === false && (
        <>
          {location.locations.map((eachLocation, index) => {
            return (
              <Location
                key={index}
                id={index + 1}
                Lat={eachLocation[0]}
                Long={eachLocation[1]}
              />
            );
          })}
        </>
      )}
    </StyledDisplayWrapper>
  );
}

const StyledDisplayWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
